import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './LeftPanelCollapseToggle.css';

/*
 * LeftPanelCollapseToggle — single-button affordance for collapsing /
 * restoring a two-pane page's left rail. Presentational; state is owned
 * by useLeftPanelCollapse on the parent page.
 *
 * Props:
 *   collapsed  (bool, required)  — current collapsed state
 *   onToggle   (fn,   required)  — fired on click
 *   className  (str,  optional)  — extra class for host-specific positioning
 *
 * Icon direction follows the action, not the state:
 *   - !collapsed → ChevronLeft  (clicking collapses the rail leftward,
 *                                expanding the work area to the right)
 *   - collapsed  → ChevronRight (clicking restores the rail back out)
 *
 * Label / title:
 *   - !collapsed → 'Expand work area'
 *   - collapsed  → 'Restore panels'
 */
export default function LeftPanelCollapseToggle({ collapsed, onToggle, className }) {
  const Icon = collapsed ? ChevronRight : ChevronLeft;
  const label = collapsed ? 'Restore panels' : 'Expand work area';
  const cls = `lpc-toggle${className ? ` ${className}` : ''}`;

  return (
    <button
      type="button"
      className={cls}
      onClick={onToggle}
      aria-label={label}
      title={label}
    >
      <Icon size={18} strokeWidth={1.5} aria-hidden="true" />
    </button>
  );
}
